import { toWebp } from "@/utils/common";
import Image from "next/image";
import React, { useEffect, useState } from "react";

interface ServeProps {
  data: {
    title?: string;
    Title?: string;
    description: string;
    points: {
      id: number;
      title: string;
      image: {
        data: {
          attributes: {
            url: string;
          };
        };
      };
    }[];
    cards: {
      future_cards: {
        id: number;
        title: string;
        Image: {
          data: {
            attributes: {
              url: string;
            };
          };
        };
      }[];
    };
  };
}
const Serve: React.FC<ServeProps> = ({ data }) => {
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(window.innerWidth < 640); // mobile check
  }, []);

  return (
    <section className="relative bg-background-white text-primary-text py-[56px] xl:py-25 md:py-[80px] overflow-hidden">
      <div className="container mx-auto px-4 text-center relative z-10">
        {/* Title */}
        <h2 className="text-heading-1 font-bold text-primary-text mb-[10px] md:mt-[0px] flex w-full text-center justify-center">
          {data?.title ?? data?.Title ?? ""}
        </h2>
        <div className="grid grid-cols-12 sm:gap-[30px] gap-[20px]">
          {/* Desktop Section */}
          {!isMobile && (
            <>
              {data?.points?.map((card: any, index: number) => (
                <div
                  key={card.id}
                  className="xl:col-span-2 sm:col-span-3 col-span-6"
                >
                  <div
                    className={`w-[180px] xl:w-[100%] h-[217px] flex flex-col items-center justify-center
                  bg-contain xl:bg-cover bg-center
                  ${
                    index % 2 === 0
                      ? "bg-[url('/images/about/s11.png')]"
                      : "bg-[url('/images/about/s22.png')]"
                  }`}
                  >
                    <div className="w-[91px] h-[91px] flex flex-col items-center justify-center bg-white">
                      {card?.image?.data?.attributes?.url && (
                        <Image
                          height={42}
                          width={42}
                          src={toWebp(
                            baseUrl + card?.image?.data?.attributes?.url
                          )}
                          alt={card.title}
                          className="w-[42px] h-[42px] object-contain"
                        />
                      )}
                    </div>
                    <p className="mt-4 text-black font-semibold text-lg">
                      {card.title}
                    </p>
                  </div>
                </div>
              ))}
            </>
          )}

          {isMobile && (
            <>
              {data?.cards?.future_cards?.map((card: any, index: number) => {
                // Mobile pattern repeats every 4 cards
                // Blue for 1,4,5,8,... → index: 0,3,4,7,... (0-based index)
                // Green for 2,3,6,7,... → index: 1,2,5,6,...
                const patternIndex = index % 8; // pattern repeats every 8 cards
                const isBlue = [0, 3, 4, 7].includes(patternIndex);

                return (
                  <div key={card.id} className="col-span-6">
                    <div
                      className={`
                  w-[180px] h-[217px] flex flex-col items-center justify-center
                  bg-cover bg-center
                  ${isBlue ? "bg-[url('/images/about/s11.png')]" : "bg-[url('/images/about/s22.png')]"}
                `}
                    >
                      <div className="w-[91px] h-[91px] flex items-center justify-center bg-white">
                        {card?.Image?.data?.attributes?.url && (
                          <Image
                            height={42}
                            width={42}
                            src={toWebp(
                              baseUrl + card?.Image?.data?.attributes?.url
                            )}
                            alt={card.title}
                            className="w-[42px] h-[42px] object-contain"
                          />
                        )}
                      </div>
                      <p className="mt-4 text-black font-semibold text-lg">
                        {card.title}
                      </p>
                    </div>
                  </div>
                );
              })}
            </>
          )}

          {/* Description */}
          <div className="xl:col-span-4 sm:col-span-6 col-span-6">
            <h2 className="text-heading-2 h-full items-end font-bold text-primary-text mb-[10px] md:mt-[0px] max-w-[500px] mx-auto flex w-full text-left">
              {data?.description}
            </h2>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Serve;
